<template>
<section class="myLoginInfo">
    <section class="user_login_info">
        <div class="wrap">
           <p>{{auth.name}} 님</p>
           <div>
                <p>{{auth.phone}}</p>
                <router-link to="/phone/pwChk">
                    연락처 변경
                    <img :src="$store.state.resource.imgIconArrowRigthSmall">
                </router-link>
           </div>
        </div>
    </section>

    <section class="social_login_info">
        <div class="wrap">
			<ul>
				<li>
					<p><span><img :src="$store.state.resource.imgIconKakao" width="40"></span>kakao</p>
					<div v-if="socialCheck('KAKAO')">연결됨</div>
					<button v-else @click="kakaoOAuth();">+ 연결하기</button>
				</li>
                
				<li>
					<p><span><img :src="$store.state.resource.imgIconGoogle" width="40"></span>Google</p>
                    <div v-if="socialCheck('GOOGLE')">연결됨</div>
					<button v-else @click="googleOAuth();">+ 연결하기</button>
				</li>

				<li v-if="agentCheck == 'ios'">
					<p><span><img :src="$store.state.resource.imgIconApple" width="40"></span>Apple</p>
                    <div v-if="socialCheck('APPLE')">연결됨</div>
					<button v-else @click="appleOAuth();">+ 연결하기</button>
				</li>
			</ul>
        </div>
    </section>

    <section class="user_login_info">
        <div class="wrap">
           <div style="margin-top:0">
               <p></p>
               <a @click="secession();">회원탈퇴<img :src="$store.state.resource.imgIconArrowRigthSmall"></a>
           </div>
        </div>
    </section>

</section>
</template>

<script>
import { SocialMixin } from '../../mixins/SocialMixin';

export default {
    name:'MyInfo',

    mixins:[SocialMixin],

    data() {
        return {}
    },

    computed: {},

    created() {
        this.$store.state.headerTitle = '계정 정보';
        this.$store.commit('SHOW_ONLOAD');
    },

    mounted() {},
    
    methods: { 
        
        secession() {
            
            try {
                this.$store.commit('OPEN_MODAL', {
                    content: '탈퇴 하시겠습니까? \n 탈퇴 후 90일 동안 같은 번호로 가입이 불가능합니다.',
                    btnOne:'예',
                    btnOneSubmit: () => {
                        this.$store.dispatch('SECESSION')
                        .then(()=>{
                            this.$store.commit('OPEN_MODAL', {
                                content:'탈퇴가 완료되었습니다.',
                                btnOne:'확인',
                                btnOneSubmit: () => {
                                    this.$store.dispatch('LOGOUT')
                                    this.$router.push('/main');
                                }
                            })
                        });
                    },
                    btnTwo:'아니오',
                })

            } catch (e) {
                this.apiCatch(e);
            }
        },
    },
    
}
</script>

<style>
    #app {
        background:#fff
    }
</style>